import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, redirectingProfileEnum } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total Value", two_table_header: "Total Value (USD)" },
  // { value: 'weight', label: 'Total Weight'},
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
];
export const defaultData = {
  name: "Argentina Exports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  showUiTrends: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  isViewAllGridNew: true,
  isUIGridNew: true,
  isUEGridNew: true,
  minimumDateAllowed: "2019-01-01",
  isImpExpGraph: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("argentinaExportLatestArrivalDate"),
    getSearchResult: getApiUrl("argentinaExportSearch"),
    getAnalyticsData: getApiUrl("analytics/argentinaExportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_argentina_exports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_argentina_exports"),
    getShipmentByID: getApiUrl("argentinaExportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfArgentinaExports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearch    PayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/argentinaExportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("importerExporterGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.ar_export.country_small,
  countryCaps: globalCountryDetails.ar_export.country_caps,
  product_id: globalCountryDetails.ar_export.product_id,
  compare_product_id: globalCountryDetails.ar_export.compareProduct,
  country_CamelCase: globalCountryDetails.ar_export.product_id,
  countryCode: globalCountryDetails.ar_export.countryCode,
  countryType: globalCountryDetails.ar_export.countryType,
  manyCountryType: globalCountryDetails.ar_export.manyCountryType,
  countryTypeCode: globalCountryDetails.ar_export.countryTypeCode,
  redirectionID: globalCountryDetails.ar_export.redirectionID,
  analyticsCountryID: globalCountryDetails.ar_export.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipments Arrival Date Range",
  monthRangeHeading: "Month of Export",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: false,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: false,
    allCategory: true,
    ports: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.ar_export.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "value",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortName",
    productCategory: "productCategory",
  },
  filterObj: {
    countryOfDestinationRegion: "countryOfDestinationRegion",
    countryOfExportRegion: "countryOfExportRegion",
    shipper: "shipper",
    modeOfTransport: "modeOfTransport",
    standardLadingPortName: "standardLadingPortName",
    hsCode: "hsCode",
    packages: "packages",
    shipmentValue: "shipmentValue",
    incoterm: "incoterm",
    purposeOfExport: "purposeOfExport",
    derivedShipperMasterName: "derivedShipperMasterName",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    sixDigitHsCode: "sixDigitHsCode",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
  },
  booleanFilterObj: {
    // include_master_bill: 'include_master_bill',
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    packages: "packages",
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    packages: [],
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    countryOfDestinationRegion: "countryOfDestination",
    countryOfExportRegion: "countryOfExport",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    countryOfDestinationRegion: [],
    countryOfExportRegion: [],
    shipper: [],
    modeOfTransport: [],
    standardLadingPortName: [],
    hsCode: [],
    packages: [],
    shipmentValue: [],
    incoterm: [],
    purposeOfExport: [],
    sections: [],
    derivedShipperMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
    shipperJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {
    // include_master_bill: true,
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    countryOfDestinationRegion: false,
    countryOfExportRegion: false,
    shipper: false,
    modeOfTransport: false,
    standardLadingPortName: false,
    hsCode: false,
    packages: false,
    shipmentValue: false,
    incoterm: false,
    purposeOfExport: false,
    sections: false,
    derivedShipperMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
    shipperJurisdictionCountryRegion: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: "shipperDetails", eventKey: "11", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: "shipperDetails", eventKey: "2", key: "shipper", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: "consigneeDetails", eventKey: "1", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: "shipperDetails", eventKey: "1", key: "countryOfExportRegion", altKey: "countryOfExport", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Office", categoryName: "ports", eventKey: "3", key: "standardLadingPortName", type: filterType.normalFilter, label: "Customs Office", viewAllPlaceHolder: "Search in Customs Office Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation", categoryName: "freightType", eventKey: "4", key: "modeOfTransport", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "", showInput: false },
    { heading: "Filter by Incoterm Filter", categoryName: "freightType", eventKey: "5", key: "incoterm", type: filterType.normalFilter, label: "Incoterm", viewAllPlaceHolder: "Search in Incoterm Filter", emptyFilterText: "", searchFilterString: "", isNoTransform: true },
    { heading: "Filter by Purpose of Export", categoryName: "freightType", eventKey: "6", key: "purposeOfExport", type: filterType.normalFilter, label: "Purpose of Export", viewAllPlaceHolder: "Search in Purpose of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Number of Packages", categoryName: "cargoDetails", eventKey: "7", key: "packages", type: filterType.boxFilter, label: "Number of Packages", viewAllPlaceHolder: "Search in Number of Packages Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: "cargoDetails", eventKey: "8", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: "cargoDetails", eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: "cargoDetails", eventKey: "8", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in 2 Digit HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value", categoryName: "cargoDetails", eventKey: "9", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value (USD)", viewAllPlaceHolder: "Search in Shipment Value (USD) Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Sections", categoryName: "cargoDetails", eventKey: "10", key: "sections", type: filterType.normalFilter, label: "Sections", viewAllPlaceHolder: "Type to Search Sections", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: "cargoDetails", eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
    {
      heading: "Filter by Shipper Jurisdiction Country",
      categoryName: "shipperDetails",
      eventKey: "25",
      key: "shipperJurisdictionCountryRegion",
      altKey: "shipperJurisdictionCountry",
      type: "localization-filter",
      label: "Shipper Jurisdiction Country",
      viewAllPlaceHolder: "Search Shipper Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterValue" },
    // { isVisible: false, key: 'uniqueImportExporterTeu',}
  ],
  highLightedColumnList: [
    { key: "export_id", label: "Export ID" },
    { key: "hs_code", label: "HS Code" },
    { key: "derived_hs_code", label: "HS Code" },
    { key: "shipper_name", label: "Shipper Name" },
    { key: "derived_shipper_master_name", label: "Shipper Standardized Name" },
    { key: "product_name", label: "Product Description (Spanish)" },
    { key: "derived_product_description_english", label: "Product Description" },
    { key: "brand_name", label: "Product Description" },
    { key: "product_variety", label: "Product Description" },
    { key: "product_attributes", label: "Product Description" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "derived_customs_office", label: "Customs Office" },
  ],
  shipmentSorting: [
    { columnKey: "shipment_date", value: "date", isDefault: true },
    // { columnKey: 'derived_weight', value: 'weight', isDefault: false },
    { columnKey: "derived_sub_item_fob_value", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    // { columnKey: 'teu', value: 'teu', isDefault: true},
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
  ],
  importerSorting: [
    // { columnKey: 'teu', value: 'teu', isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
  ],
  sortKeyMap: {
    date: "shipment_date",
    shipment_value: "derived_sub_item_fob_value",
    // teu: 'derived_shipment_teu'
  },
  sortKeyUniqueImpExpMap: {
    // teu: 'teu',
    date: "doc_count",
    shipment_value: "shipment_value",
  },
  analyticsHeaderItems: [
    { label: "Total Shipments Exported", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipments Weight", key: "total_weight", valuePrefix: "", valueSuffix: "Kg" },
    { label: "Total Shipments Value", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "trends", filterKey: "", label: "Export Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country_of_destination_english", filterKey: "countryOfDestinationRegion", label: "Countries of Import", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "customs_office" },
    { key: "customs_office", filterKey: "standardLadingPortName", label: "Customs Offices", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination_english", profileType: redirectingProfileEnum.portOfLading.key },
    // { key: "trade_custom_destination_country", filterKey1: "standardLadingPortName", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Customs House -> Country of Import)", headerOne: "Customs House", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "derived_mode_of_transport_english", filterKey: "modeOfTransport", label: "Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination_english" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "shipment_date", name: "Shipment Date", selector: "shipment_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true },
    { key: "derived_hs_code", name: "HS Code", selector: "derived_hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "product_name", name: "Product", selector: "product_name", tooltipValue: "product_name", type: "", grow: 1, wrap: true, isSliceEnabled: true, sliceLength: 40 },
    { key: "sub_item_quantity", name: "Quantity", selector: "sub_item_quantity", secondarySelector: "derived_commercial_unit_english", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "incoterm", name: "Incoterm", selector: "incoterm", dataTip: "", type: "", grow: 0, wrap: true, miWidth: "80px", maWidth: "80px" },
    { key: "incoterm", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "shipper_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true },
    { key: "derived_country_of_destination_english", name: "Country of Import", selector: "derived_country_of_destination_english", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "derived_sub_item_fob_value", name: "Shipment Value (USD)", selector: "derived_sub_item_fob_value", dataTip: "", type: "", grow: 1, wrap: true, sortable: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 2, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Shipment Date", value: "shipment_date", dateFormat: true, monthFormat: false },
        { label: "Export ID", value: "export_id", capitalize: true },
        { label: "Item Number", value: "itemCount" },
        { label: "Sub Item Number", value: "subItemCount", isViewAll: "is_view_all", shipmentRedirect: true, requestId: "export_id", requestNum: "item_number" },
        { label: "Mode of Transportation", value: "derived_mode_of_transport_english", tooltip: true, tooltipField: "mode_of_transport", tooltipPrefix: "" },
        { label: "Incoterm", value: "incoterm", capitalize: true, tooltip: true, tooltipField: "derived_incoterm_english", tooltipPrefix: "" },
        { label: "Purpose of Export", value: "derived_operation_type_english", tooltip: true, tooltipField: "operation_type", tooltipPrefix: "" },
        { label: "Sub-Item Shipment FOB", value: "derived_sub_item_fob_value", valuePrefix: "USD " },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "HS Code", value: "derived_hs_code" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name" },
        { label: "Shipper Name", value: "shipper_name" },
        { label: "Customs Office", value: "derived_customs_office", tooltip: true, tooltipField: "derived_customs_office", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        {
          label: "Shipper Jurisdiction Country",
          value: "derived_shipper_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_shipper_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [{ label: "Country of Import", value: "derived_country_of_import", tooltip: true, tooltipField: "country_of_destination", tooltipPrefix: "Country Code: ", countryFlag: true, countryCodeField: "derived_country_of_import_code" }],
    },
    {
      id: 4,
      title: "Export ID Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        // {label: 'Carrier Name', value: 'carrier_name', isCapitalise: true,},
        // {label: 'Carrier Country', value: 'derived_carrier_country_english', tooltip: true, tooltipField: 'carrier_country', isCapitalise: true,},
        // {label: 'Voyage Number', value: 'voyage_number',},
        // {label: 'Vessel Name', value: 'vessel_name', isCapitalise: true,},
        // {label: 'VOCC', value: 'derived_vocc_name', tooltip: true, tooltipField: 'derived_vocc_code', tooltipPrefix: 'VOCC Code: ', isCapitalise: true,},
        // {label: 'NVOCC', value: 'derived_nvocc_name', tooltip: true, tooltipField: 'derived_nvocc_code', tooltipPrefix: 'NVOCC Code: ', isCapitalise: true,},
        { label: "Total FOB Value", value: "fob_value", valuePrefix: "USD ", tooltip: true, tooltipField: "customs_office_code_zone", tooltipPrefix: "Customs Office Code: " },
        { label: "Total CIF Value", value: "cif_value", valuePrefix: "USD " },
        { label: "Number Of Packages", value: "number_of_packages", valueSuffix: " Packages" },
        { label: "Gross weight", value: "gross_weight", valueSuffix: " kg" },
      ],
    },
    {
      id: 5,
      title: "Item Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        // {label: 'Load Type', value: 'derived_load_type_english', tooltip: true, tooltipField: 'load_type', isCapitalise: true,},
        // {label: 'Package Type', value: 'derived_package_type_english', tooltip: true, tooltipField: 'package_type', isCapitalise: true,},
        // {label: 'Package Quantity', value: 'package_quantity',},
        // {label: 'Gross Weight (kg)', value: 'derived_shipment_gross_weight_kg',},
        // {label: 'Gross Weight (tonne)', value: 'derived_gross_weight_tonne',},
        // {label: 'Package Description', value: 'package_description', isCapitalise: true,},
        { label: "Item Number", value: "item_number" },
        { label: "Item FOB Value", value: "fob_per_item", valuePrefix: "USD " },
        { label: "Item CIF Value", value: "cif_per_item", valuePrefix: "USD " },
        { label: "Item Commercial Quantity", value: "commercial_quantity", unitField: "derived_commercial_unit_english", dynamicUnit: true, unitField2: "", dynamicUnit2: false, tooltip: false, tooltipField: "", tooltipField2: "" },
      ],
    },
    {
      id: 6,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        // {label: 'HS Code', value: 'hs_code'},
        // {label: 'Product Description', value: 'derived_product_description',},
        // {label: 'CIF Value (USD)', value: 'cif_value',},
        // {label: 'Insurance Value (USD)', value: 'insurance_value',},
        // {label: 'Freight Value (USD)', value: 'freight_value',},
        // {label: 'FOB Value (USD)', value: 'fob_value',},
        // {label: 'FOB per Unit (USD)', value: 'fob_per_unit',},
        // {label: 'CIF per Unit (USD)', value: 'derived_cif_per_unit',},
        // {label: 'Quantity', value: 'quantity', unitField: 'derived_measure_unit_english', dynamicUnit: true, preValidate: true,},
        { label: "Sub-Item Number", value: "sub_item_number", tooltip: true, tooltipField: "customs_office_code_zone", tooltipPrefix: "Customs Office Code: " },
        { label: "Sub Item FOB Value", value: "derived_sub_item_fob_value", valuePrefix: "USD " },
        { label: "Sub Item Quantity", value: "sub_item_quantity", unitField: "derived_commercial_unit_english", dynamicUnit: true },
        { label: "Product Description", value: "derived_product_description_english", isReadMore: true, readMoreLength: 45 },
        { label: "Product Description (Spanish)", value: "product_name", isReadMore: true, readMoreLength: 45 },
        { label: "Brand", value: "brand_name" },
        { label: "Variety", value: "product_variety" },
        { label: "Attributes", value: "product_attributes" },
      ],
    },
    // {
    //     id: 6,
    //     title: "Container Details",
    //     growValue: 12,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
    //     isContainer: true,
    //     mainKey: 'container_details',
    //     uniqueKey: 'id',
    //     data: [
    //         {
    //             title: "Container Identifiers",
    //             titleKey: '',
    //             isNested: false,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Container Number', value: 'container_number', defaultValue: 'NA' },
    //                 { label: 'Seal Number', value: 'seal_number', defaultValue: 'NA' },
    //                 { label: 'Type of Service', value: 'type_of_service', defaultValue: 'NA' },
    //                 { label: 'Load Status', value: 'load_status', defaultValue: 'NA' },
    //                 { label: 'Marks & Numbers', value: 'marks_and_numbers', defaultValue: 'NA' },
    //                 { label: 'Equipment Desc.', value: 'equipment_description', defaultValue: 'NA' },
    //             ]
    //         },
    //         {
    //             title: "Container Dimension",
    //             titleKey: '',
    //             isNested: false,
    //             isContainerDimension: true,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Length', value: 'length', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Height', value: 'height', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Width', value: 'width', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Type', value: 'type', defaultValue: 'NA' }
    //             ]
    //         },
    //         {
    //             title: "Cargo Description",
    //             titleKey: '',
    //             isNested: true,
    //             nestedKey: "cargo_description_tables",
    //             nestedNumber: 'desc_seq_number',
    //             childData: [
    //                 { label: 'Piece Count', value: 'piece_count', defaultValue: 'NA', dynamicUnit: true, unitField: 'manifest_unit',},
    //                 { label: 'Description', value: 'cargo_description', defaultValue: 'NA', isReadMore: true, readMoreLength: 65,},
    //                 // { label: '', value: 'table', isTable: true, tableHeaderKey: ['HS Code', 'Value (USD)', 'Weight (kg)'], tableContentKey:['hscode', 'value', 'weight'] }
    //             ]
    //         },
    //         {
    //             title: "HAZMAT Sequence",
    //             titleKey: 'hazmat_sequence_number',
    //             isNested: true,
    //             nestedKey: "hazmat_sequence_tables",
    //             nestedNumber: 'hazmat_sequence_number',
    //             childData: [
    //                 { label: 'Sequence Number', value: 'hazmat_sequence_number', defaultValue: 'NA' },
    //                 { label: 'Code', value: 'hazmat_code', defaultValue: 'NA' },
    //                 { label: 'Class', value: 'hazmat_class', defaultValue: 'NA' },
    //                 { label: 'Code Qualifier', value: 'hazmat_code_qualifier', defaultValue: 'NA' },
    //                 { label: 'Contact', value: 'hazmat_contact', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp.', value: 'hazmat_flash_point_temperature', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Negative Ind', value: 'hazmat_flash_point_temperature_negative_ind', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Unit', value: 'hazmat_flash_point_temperature_unit', defaultValue: 'NA' },
    //                 { label: 'Description', value: 'hazmat_description', defaultValue: 'NA' },
    //                 { label: 'Classification', value: 'hazmat_classification', defaultValue: 'NA' },
    //             ]
    //         },
    //     ]
    // },
  ],
  defaultUeUiSecondLevelKey: "derived_country_of_destination_english",
  twoColumnMapping: {
    // derived_consignee_master_name:"Unique Importers",
    trade_country_of_export_to_import: "Trade Routes (Country of Export -> Country of Import)",
    derived_shipper_master_name: "Unique Exporters",
    derived_country_of_destination_english: "Countries of Import",
    customs_office: "Customs Offices",
    trade_custom_destination_country: "Trade Routes (Customs House -> Country of Import)",
    derived_mode_of_transport_english: "Mode of Transportation",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const ArgentinaExportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default ArgentinaExportSearch;
